<template lang="pug">
  transition(name="slide-fade-up")
    .notification(
      v-if="visible"
      :class="classes"
    )
      a.close(href="#" @click.stop.prevent="closeMessage" title="Schließen")
        svg(
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        )
          path(
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
            d="M6 18L18 6M6 6l12 12"
          )
      .heading(
        v-if="content.title"
        v-html="content.title"
      )
      p(v-html="content.text")
      hr(v-if="content.info")
      div(
        v-if="content.info"
        v-html="content.info"
      )
</template>
<script>
import { mapMutations } from 'vuex';

let timeout;

export default {
    name: 'Message',
    data() {
        return {
            visible: false
        };
    },
    props: {
        content: {
            type: Object,
            required: false
        }
    },
    watch: {
        'content.highlight': function(highlight) {
            if (highlight && timeout && this.content.autoclose) {
                clearTimeout(timeout);
                timeout = setTimeout(() => this.closeMessage(), this.content.autoclose);
            }
        }
    },
    computed: {
        classes() {
            let classes = {};
            classes[`is-${this.content.type}`] = true;
            classes['focused'] = this.content.highlight || false;

            return classes;
        }
    },
    methods: {
        closeMessage() {
            this.removeMessage(this.content.id);
        },
        ...mapMutations({
            removeMessage: 'message/remove'
        })
    },
    mounted() {
        setTimeout(() => {
            this.visible = true;
        }, 10);
        if (this.content.autoclose) timeout = setTimeout(() => this.closeMessage(), this.content.autoclose);
    }
};
</script>
<style lang="sass" scoped>
.notification
  @apply px-4 py-3 pr-10 rounded bg-gray-800 text-white shadow-md relative
  transform-origin: 120px center
  max-width: calc(100% - 80px)
  @screen lg
    min-width: 280px
    max-width: 420px
  &.focused
    animation: bounce 200ms cubic-bezier(0.24, 0, 0.38, 1)
    // &:before
    //   content: ''
    //   position: absolute
    //   width: 20px
    //   height: 20px
    //   top: calc(50% - 10px)
    //   left: calc(100% + 20px)
    //   background-color: inherit
    //   border-radius: 29px
    //   animation: ping 900ms cubic-bezier(0.24, 0, 0.38, 1)
    //   animation-iteration-count: 1
    // &:before
    //   content: ''
    //   display: block
    //   position: absolute
    //   width: 20px
    //   height: 20px
    //   top: calc(50% - 10px)
    //   left: calc(100% + 20px)
    //   background-color: inherit
    //   border-radius: 29px
    //   transition: opacity .3s, transform .3s
    //   // animation: pulse-animation 1s cubic-bezier(0.24, 0, 0.38, 1)
    //   z-index: -1
  &.is-danger,
  &.is-error
    @apply bg-red-600
  &.is-success
    @apply bg-green-600

  hr
    margin: 1.3rem 0
    opacity: 0.6
    height: 1px
  .heading
    font-weight: 500
    line-height: 1
    margin-bottom: 5px
    font-size: 1.2rem
  .close
    position: absolute
    right: .6rem
    top: .6rem
    line-height: 1
    cursor: pointer
    width: 20px
</style>
